/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NfcToken
 */
export interface NfcToken {
    /**
     * 
     * @type {string}
     * @memberof NfcToken
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof NfcToken
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof NfcToken
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof NfcToken
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof NfcToken
     */
    userId: string;
}

/**
 * Check if a given object implements the NfcToken interface.
 */
export function instanceOfNfcToken(value: object): value is NfcToken {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function NfcTokenFromJSON(json: any): NfcToken {
    return NfcTokenFromJSONTyped(json, false);
}

export function NfcTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): NfcToken {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'description': json['description'],
        'userId': json['userId'],
    };
}

export function NfcTokenToJSON(json: any): NfcToken {
    return NfcTokenToJSONTyped(json, false);
}

export function NfcTokenToJSONTyped(value?: NfcToken | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'description': value['description'],
        'userId': value['userId'],
    };
}

